var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _ellipse, _circle7, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewCampaigns(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 722,
    height: 568.282,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m443.382 504.734-19.27 17.74 15.314-25.695c-12.064-21.879-31.796-40.787-31.796-40.787s-40.937 39.22-40.937 70.05 18.328 41.594 40.937 41.594c22.608 0 40.936-10.764 40.936-41.594 0-6.862-2.031-14.14-5.184-21.308Z",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M419.157 523.434v1.52c-.09 17.663-3.069 31.445-8.914 41.15-.083.143-.173.278-.256.421l-.655-.398-.624-.392c6.485-10.48 8.78-25.292 8.862-40.699.008-.497.015-1 .008-1.505-.023-6.522-.422-13.12-1.061-19.53-.045-.496-.098-1-.15-1.504-.888-8.456-2.167-16.535-3.476-23.554-.09-.497-.188-.993-.286-1.482-2.264-11.872-4.574-20.47-5.1-22.374-.06-.233-.098-.361-.106-.391l.715-.203.007-.008.722-.203c.008.03.136.46.346 1.257.805 2.979 2.897 11.066 4.95 21.733.09.482.189.978.279 1.475 1.068 5.695 2.114 12.06 2.941 18.74q.316 2.516.565 4.965c.06.504.113 1.008.158 1.505q1.038 10.393 1.075 19.477Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M414.14 477.272a47.34 47.34 0 0 1-1.535.188 41.502 41.502 0 0 1-4.243.219 40.371 40.371 0 0 1-17.453-3.942c-.316.398-.632.797-.956 1.203a41.866 41.866 0 0 0 18.409 4.243 42.94 42.94 0 0 0 4.529-.24c.511-.053 1.023-.12 1.527-.196a41.514 41.514 0 0 0 12-3.634q-.486-.62-.949-1.218a40.233 40.233 0 0 1-11.33 3.377Zm3.784 25.18q-.779.045-1.558.045c-.158.008-.323.008-.481.008a40.585 40.585 0 0 1-33.312-17.401c-.3.444-.602.888-.895 1.339a42.092 42.092 0 0 0 34.207 17.566c.21 0 .421 0 .632-.007a53.672 53.672 0 0 0 1.565-.045 41.87 41.87 0 0 0 22.305-7.824c-.24-.444-.481-.888-.73-1.332a40.307 40.307 0 0 1-21.733 7.65Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M419.157 523.434a42.388 42.388 0 0 1-3.272.135 40.695 40.695 0 0 1-39.014-29.28c-.339.61-.677 1.212-1 1.821a42.185 42.185 0 0 0 40.014 28.964c.564 0 1.128-.008 1.685-.038a36.08 36.08 0 0 0 1.587-.083 42.062 42.062 0 0 0 27.76-13.549c-.158-.556-.338-1.106-.519-1.662a40.564 40.564 0 0 1-27.24 13.692Z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 98.754,
    cy: 101.778,
    r: 98.754,
    fill: "#e4e4e4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.754,
    cy: 101.778,
    r: 82.295,
    fill: "#48b2d2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 361,
    cy: 101.778,
    r: 98.754,
    fill: "#e4e4e4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 361,
    cy: 101.778,
    r: 82.295,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.246,
    cy: 101.778,
    r: 98.754,
    fill: "#e4e4e4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 623.246,
    cy: 101.778,
    r: 82.295,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.76 131.538q-.22 0-.441-.01a9.035 9.035 0 0 1-6.699-3.481l-12.624-16.23a9.054 9.054 0 0 1 1.586-12.692l.455-.353a9.055 9.055 0 0 1 12.691 1.586 8.044 8.044 0 0 0 12.19.594l25.632-27.058a9.044 9.044 0 0 1 12.785-.345l.419.397a9.043 9.043 0 0 1 .345 12.784l-39.775 41.984a9.033 9.033 0 0 1-6.563 2.824Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M317.657 81.782h-65v-56.53a13.225 13.225 0 0 1 13.437-12.97h21.607c16.518 0 29.956 12.972 29.956 28.916Z",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb6b6",
    d: "m341.722 554.819-12.339-.001-5.871-47.595 18.212.001-.002 47.595z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m344.87 566.78-39.789-.001v-.504a15.487 15.487 0 0 1 15.487-15.486l24.302.001Z",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb6b6",
    d: "m227.987 554.819-12.34-.001-5.87-47.595 18.212.001-.002 47.595z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m231.134 566.78-39.788-.001v-.504a15.487 15.487 0 0 1 15.487-15.486l24.302.001Z",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb6b6",
    d: "m242.886 172.448-8.052 51.332 76.494 1.006-10.065-49.318-58.377-3.02z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m237.054 211.246-24.363 64.872-3.02 268.84h20.634l49.318-215.998 45.293 210.36h20.13l-14.09-236.53s4.154-47.473-17.112-75.487l-5.176-14.955Z",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M341.558 261.817a15.1 15.1 0 0 1-9.675-21.036l-32.542-106.094 23.936-4.745 29.763 103.995a15.182 15.182 0 0 1-11.482 27.88Z",
    fill: "#ffb6b6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m298.492 200.797-52.73-1.018a6.894 6.894 0 0 1-6.533-5.193c-2.827-11.192-9.046-40.36-5.748-69.41a42.365 42.365 0 0 1 48.153-37.06 42.384 42.384 0 0 1 34.988 52.72c-6.637 25.207-10.387 43.24-11.143 53.6a6.878 6.878 0 0 1-5.51 6.231 6.857 6.857 0 0 1-1.33.131l-.147-.001Z",
    fill: "#e4e4e4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M138.322 107.605a14.795 14.795 0 0 1 .778 2.196l66.003 22.428 12.754-11.142 19.33 17.05-20.661 21.918a11.245 11.245 0 0 1-13.298 2.301l-70.627-36.076a14.755 14.755 0 1 1 5.721-18.675Z",
    fill: "#ffb6b6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M205.24 128.652a6.319 6.319 0 0 1 2.222-4.775l24.167-20.586a17.567 17.567 0 0 1 26.529 23.034l-17.21 26.8a6.325 6.325 0 0 1-9.483 1.345l-24.061-21.015a6.318 6.318 0 0 1-2.164-4.803Zm92.643 32.908a6.318 6.318 0 0 1-3.216-4.17l-7.145-30.932a17.567 17.567 0 0 1 32.662-12.943l15.865 27.618a6.325 6.325 0 0 1-3.172 9.037l-29.734 11.681a6.318 6.318 0 0 1-5.26-.29Z",
    fill: "#e4e4e4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 548.664,
    cy: 177.771,
    rx: 11.254,
    ry: 15.005,
    transform: "rotate(-66.87 303.561 275.833)",
    fill: "#2f2e41"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 511.819,
    cy: 211.388,
    r: 30.775,
    transform: "rotate(-61.337 252.474 329.972)",
    fill: "#ffb6b6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M289.7 10.282h-35.2a10.228 10.228 0 0 0-10.32 9.334 10 10 0 0 0 9.978 10.666 10 10 0 0 1 10 10v41h55V39.74A29.457 29.457 0 0 0 289.7 10.282Z",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M463.224 568.282h-381a1 1 0 0 1 0-2h381a1 1 0 0 1 0 2Z",
    fill: "#cacaca"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCampaigns);
export default __webpack_public_path__ + "static/media/newCampaigns.35e7151a1558d0ed33c92a0bcc1ec55a.svg";
export { ForwardRef as ReactComponent };